import { Control, Controller } from 'react-hook-form';
import { NumericFormat } from 'react-number-format';
import { realisation as rules } from 'further-ui/validations';
import { AppTextInput } from 'components/FormElements';
import { useState } from 'react';
import { AllocationRule } from 'further-types/lp/allocations';

type Props = {
  considerationIndex: number;
  allocationIndex: number;
  control: Control<rules.CreateRealisationFormValues>;
  setInvestorAllocations: (considerationIndex: number) => void;
  setInvestorAllocationType: (params: {
    considerationIndex: number;
    investmentId: string;
    newAllocationType: AllocationRule;
  }) => void;
  investmentId: string;
};

const AllocationPercentageCell: React.FC<Props> = ({
  considerationIndex,
  allocationIndex,
  control,
  setInvestorAllocations,
  setInvestorAllocationType,
  investmentId,
}) => {
  const [isFocused, setIsFocused] = useState(false);
  return (
    <Controller
      control={control}
      name={`consideration.${considerationIndex}.investorAllocations.${allocationIndex}.allocationPercentage`}
      render={({ field: { ref, onChange, ...rest } }) => (
        <NumericFormat
          {...rest}
          inputRef={ref}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          onValueChange={({ value }) => {
            if (isFocused) {
              onChange(+value);
              setInvestorAllocations(considerationIndex);

              setInvestorAllocationType({
                considerationIndex,
                investmentId,
                newAllocationType: AllocationRule.Manual,
              });
            }
          }}
          isAllowed={(values) => {
            const { floatValue } = values;
            return floatValue === undefined || floatValue <= 100;
          }}
          placeholder="0"
          decimalScale={3}
          fullWidth
          suffix="%"
          allowNegative={false}
          thousandSeparator={true}
          customInput={AppTextInput}
          size="small"
        />
      )}
    />
  );
};

export default AllocationPercentageCell;
